"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coins = exports.coin = void 0;
var big_js_1 = require("big.js");
big_js_1.Big.DP = 100;
big_js_1.Big.PE = 100;
function coin(amount, denom) {
    var amountInBN = new big_js_1.Big(amount);
    if (amountInBN.cmp(0) === -1 || amount.includes('.')) {
        throw new Error('Invalid amount string.');
    }
    return { amount: amountInBN.toString(), denom: denom };
}
exports.coin = coin;
function coins(amount, denom) {
    return [coin(amount, denom)];
}
exports.coins = coins;
//# sourceMappingURL=coins.js.map